import React from 'react'

import { Alert } from '@cinch-labs/design-system'
import RichText from '@cinch/oxd-components/rich-text/src'
import SellInputForm from '@cinch/oxd-components/sell-input-form/src'
import Statuses from '@cinch/oxd-utils/request-status/src'

import Spinner from '../../components/spinner/spinner.component'
import Steps from '../../components/steps'
import WbacWrapper from '../../components/wrapper/wrapper.component'
import useToken from '../../hooks/token.hook'

import * as styles from './landing-page.module.css'
import { Pages } from '../../types'

interface Props {
  disclaimer: React.ReactNode
  i18n: Cinch.WebAppTranslations['sellVehicle']
  isRetry?: boolean
  vrm?: string
  path: Pages
}

const Page: React.FC<Props & any> = ({ disclaimer, i18n, isRetry, vrm, path }) => {
  const { token, status } = useToken()
  const isPending = status === Statuses.PENDING
  const hasError = status === Statuses.ERROR

  return (
    <div data-testid="landingPage">
      <WbacWrapper>
        {isPending && <Spinner />}
        {hasError && <Alert oxford={true}>{i18n.error}</Alert>}
        {token && (
          <>
            <Steps page={path} />
            <SellInputForm i18n={i18n} isRetry={isRetry} vrm={vrm} />
            <div className={styles.disclaimer}>
              <RichText>{disclaimer}</RichText>
            </div>
          </>
        )}
      </WbacWrapper>
    </div>
  )
}

export default Page
